import Constants from '../../constants/AuthConstant';

const initialState = {
    loading: false,
    tenant: {},
    CreateTenant:{},
    PaymentTenant:{},
    CountryStateCities:[],
    error: '',
    SkippedPayment:{},
};

const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case Constants.FETCH_USER_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case Constants.FETCH_USER_SUCCESS:
            return {
                loading: false,
                maintenance: action.payload,
                error: '',
            };
        case Constants.FETCH_USER_FAILURE:
            return {
                loading: false,
                maintenance: {},
                error: action.payload,
            };
        default:
            return state;
    }
};
export const tenantReducer = (state = initialState, action) => {
    switch (action.type) {
        case Constants.TENANT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case Constants.TENANT_SUCCESS:
            return {
                loading: false,
                tenant: action.payload,
                error: '',
            };
        case Constants.TENANT_FAILURE:
            return {
                loading: false,
                tenant: null,
                error: action.payload,
            };
        default:
            return state;
    }
};

export const CreateTenantReducer = (state = initialState, action) => {
    switch (action.type) {
        case Constants.CREATE_TENANT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case Constants.CREATE_TENANT_SUCCESS:
            return {
                loading: false,
                CreateTenant: action.payload,
                error: '',
            };
        case Constants.CREATE_TENANT_FAILURE:
            return {
                loading: false,
                CreateTenant: null,
                error: action.payload,
            };
            case Constants.UPDATE_TENANT_PAYEMENT_REQUEST:
            return {
                ...state,
                loading: true,
            };
            case Constants.UPDATE_TENANT_PAYEMENT_SUCCESS:
            return {
                loading: false,
                PaymentTenant: action.payload,
                error: "",
            };
            case Constants.UPDATE_TENANT_PAYEMENT_FAILURE:
            return {
                loading: false,
                PaymentTenant: null,
                error: action.payload,
            };
        default:
            return state;
    }
};
export const GetAllCitiesFromStateReducer = (state = initialState, action) => {

    switch (action.type) {
        case Constants.GET_ALLCITIESFROMSTATE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case Constants.GET_ALLCITIESFROMSTATE_SUCCESS:
            return {
                loading: false,
                CountryStateCities: action.payload,
                error: '',
            };
        case Constants.GET_ALLCITIESFROMSTATE_FAILURE:
            return {
                loading: false,
                CountryStateCities: null,
                error: action.payload,
            };
        default:
            return state;
    }
};

export const SetSkippedPaymentReducer = (state = initialState, action) => {

    switch (action.type) {
        case Constants.SET_SKIPPED_PAYMENT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case Constants.SET_SKIPPED_PAYMENT_SUCCESS:
            return {
                loading: false,
                SkippedPayment: action.payload,
                error: '',
            };
        case Constants.SET_SKIPPED_PAYMENT_FAILURE:
            return {
                loading: false,
                SkippedPayment: null,
                error: action.payload,
            };
        default:
            return state;
    }
};
export default userReducer;
